__turbopack_context__.v({
  "PromoCardSmall": "styles-module-scss-module__OKeyeG__PromoCardSmall",
});
